import type { AutocompleteOption } from "../../shared/components/AutocompleteSelect";

export const requestCategoryOptions: AutocompleteOption[] = [
  { value: "Ambalaj", label: "Ambalaj", keywords: ["koli", "şişe", "etiket"] },
  { value: "Hammadde", label: "Hammadde", keywords: ["gıda", "üretim"] },
  { value: "Sarf Malzeme", label: "Sarf Malzeme", keywords: ["tüketim", "yardımcı malzeme"] },
  { value: "Bakım ve Teknik Hizmet", label: "Bakım ve Teknik Hizmet", keywords: ["servis", "onarım", "periyodik bakım"] },
  { value: "Makine ve Yedek Parça", label: "Makine ve Yedek Parça", keywords: ["ekipman", "motor", "pompa"] },
  { value: "Lojistik", label: "Lojistik", keywords: ["nakliye", "depolama"] },
  { value: "Kalite ve Laboratuvar", label: "Kalite ve Laboratuvar", keywords: ["analiz", "test", "kalite kontrol"] },
  { value: "Bilgi Teknolojileri", label: "Bilgi Teknolojileri", keywords: ["yazılım", "donanım", "lisans"] },
  { value: "Ofis ve İdari", label: "Ofis ve İdari", keywords: ["kırtasiye", "mobilya"] },
  { value: "Genel", label: "Genel" },
];

export const planningRequestCategoryOptions = requestCategoryOptions.filter(
  (option) => option.value === "Hammadde" || option.value === "Ambalaj",
);

export const unitOptions: AutocompleteOption[] = [
  { value: "adet", label: "adet" },
  { value: "kg", label: "kg", description: "Kilogram" },
  { value: "ton", label: "ton" },
  { value: "litre", label: "litre" },
  { value: "metre", label: "metre" },
  { value: "m²", label: "m²", description: "Metrekare" },
  { value: "rulo", label: "rulo" },
  { value: "koli", label: "koli" },
  { value: "paket", label: "paket" },
  { value: "set", label: "set" },
  { value: "palet", label: "palet" },
  { value: "hizmet", label: "hizmet" },
];

export const supplierCategoryOptions: AutocompleteOption[] = [
  { value: "Ambalaj", label: "Ambalaj" },
  { value: "Hammadde", label: "Hammadde" },
  { value: "Makine ve Ekipman", label: "Makine ve Ekipman" },
  { value: "Bakım ve Servis", label: "Bakım ve Servis" },
  { value: "Lojistik", label: "Lojistik" },
  { value: "Laboratuvar", label: "Laboratuvar" },
  { value: "Bilgi Teknolojileri", label: "Bilgi Teknolojileri" },
  { value: "Genel", label: "Genel" },
];
